<template>
  <v-container
    fluid
    class="grid-list-lg pa-0"
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
      >
        <v-select
          :items="availableHomePageItems"
          :disabled="disabled"
          :value="selectedPage"
          persistent-hint
          :hint="hint"
          v-bind="$attrs"
          @blur="$emit('blur')"
          @focus="$emit('focus')"
          @input="onInputPage"
        />
      </v-flex>
      <v-flex
        xs12
        sm6
      >
        <v-select
          :items="allowedSites"
          :disabled="!selectedPage || disabled"
          item-id="idAlias"
          item-value="idAlias"
          item-text="name"
          :value="selectedSite"
          return-object
          @blur="$emit('blur')"
          @focus="$emit('focus')"
          @input="onInputSite"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isEmpty, get } from 'lodash';
import { staffHomePageItems, getRouteKey } from '@/modules/staff/config/homepage';

export default {
  name: 'NxStaffHomepageSelector',
  props: {
    value: {
      type: Object,
      default: null,
    },
    disabled: Boolean,
  },
  computed: {
    ...mapGetters(['allowedSites']),
    selectedPage() {
      if (!this.value) {
        return null;
      }
      return getRouteKey(this.value);
    },
    selectedSite() {
      return get(this.value, 'params.site')
        || get(this.allowedSites, '[0].idAlias')
        || null;
    },
    availableHomePageItems() {
      return Object.keys(staffHomePageItems)
        .map(routeKey => ({
          id: routeKey,
          value: routeKey,
          text: this.$t(`message.homepage.${routeKey}`),
        }));
    },
    hint() {
      if (isEmpty(this.value)) {
        return null;
      }
      const { href } = this.$router.resolve(this.value);
      return window.location.origin + href;
    },
  },
  methods: {
    onInputPage(routeKey) {
      this.$emit('input', this.buildRouteFromValue(staffHomePageItems[routeKey], this.selectedSite));
    },
    onInputSite(site) {
      if (this.selectedPage) {
        this.$emit('input', this.buildRouteFromValue(this.value, site.idAlias));
      }
    },
    buildRouteFromValue(value, site) {
      const route = cloneDeep(value);
      route.params = route.params || {};
      route.params.site = site;
      return route;
    },
  },
};
</script>
